<template>
  <div class="xslt-template w-full h-full" :class="{ haspdf: hasPdf}">
    <div class="loader" v-if="isGeneralLoading">
      <loading :opacity="0" :active.sync="isGeneralLoading" color="var(--primary-DEFAULT)"></loading>
    </div>
    <detail-layout-two-columns v-if="hasModuleCustomXslt" class="h-full">
      <template slot="LeftCol">
        <base-header style="padding-left: 0px" icon="user" :content="header" />
        <div class="form-wrapper w-full">
          <el-form :model="form" :rules="rules" ref="ruleForm">
            <div class="lg:mb-2">
              <label class="text-sm font-semibold text-secondary-600 block mb-1">{{ $t('plantilla_pdf.verifactu_qr_position') }}</label>
              <el-form-item prop="positionQRVerifactu">
                <base-el-select ref="qr" class="w-full" :options="optionsQR" v-model="form.positionQRVerifactu" filterable :loading="isGeneralLoading"/>
              </el-form-item>
              <el-form-item prop="idPlantilla">
                <base-el-select ref="templates" class="w-full" :options="baseTemplates" v-model="form.idPlantilla" :exclude-falsys="['']"
                  :option-value="optionValue" :clearable="clearable" filterable :loading="isGeneralLoading" :append-disabled="!selected"
                  @input="onBaseTemplateInput" @append-click="toggleHtml">
                  <template #append>
                    <base-icon :name="showHtml ? 'eye' : 'eyeslash'" />
                  </template>
                </base-el-select>
              </el-form-item>
            </div>
            <div class="mb-6 flex">
              <div class="w-full">
                <label class="text-sm font-semibold text-secondary-600 block mb-1">{{ $t('plantilla_pdf.registration_data_location') }}</label>
                <el-switch class="switch-text break-normal both-switch" 
                    v-model="form.textoIzq" 
                    :active-text="$t('plantilla_pdf.left_margin')" 
                    :inactive-text="$t('plantilla_pdf.page_footer')"
                    inactive-color="var(--primary-800)"
                    :disabled="!selected" />
              </div>
              <div class="w-full">
                <label class="text-sm font-semibold text-secondary-600 block mb-1">{{ $t('plantilla_pdf.languaje_for_foreings') }}</label>
                <el-switch class="switch-text break-normal both-switch" 
                    v-model="form.TraducirParaExtranjeros" 
                    :active-text="$t('langs.en')" 
                    :inactive-text="$t('langs.es')"
                    inactive-color="var(--primary-800)"
                    :disabled="!selected" />
              </div>
            </div>
            <div v-if="hasLogos || numLogos > 0">
              <template v-for="(logoData, index) in logosList">
                <div v-if="numLogos >= index + 1" :key="index">
                  <div class="flex items-center mb-2">
                    <label class="text-sm font-semibold text-secondary-600 block">{{$t('plantilla_pdf.logo_custom')}} <span v-if="numLogos > 1">{{index + 1}}</span></label>
                    <base-tooltip-icon size="sm" :content="tooltipContentLogo" class="ml-2"/>
                  </div>
                  <div class="mb-6">
                    <div class="px-2 mb-2 lg:mb-0">
                      <el-form-item :prop="`fileLogo${index + 1}`" ref="uploadlogo">
                        <Upload
                          id="pfxselector"
                          class="bg-white dark:bg-darkblue-900"
                          :class="[isLower1024 ? 'custom-upload-cert' : 'custom-upload ', { 'is-disabled': !selected || numLogos < index + 1 }]"
                          :show-file-list="false"
                          drag
                          action="#"
                          accept="image/png,image/webp,image/jpeg"
                          :multiple="false"
                          :auto-upload="false"
                          :disabled="!selected || numLogos < index + 1"
                          :on-remove="() => handleRemoveLogo(index)"
                          :on-change="(logo) => handleChangeLogo(logo, index)">
                          <i class="el-icon-upload"></i>
                          <p v-if="logoData.fileLogo.name" class="el-upload__text"><em>{{logoData.fileLogo.name}}</em></p>
                          <div v-else class="el-upload__text" v-safe-html="$tc('app.upload_default_no_file_text', 1)"></div>
                        </Upload>
                      </el-form-item>
                    </div>
                    <div>
                      <div v-if="logoData.validLogoImage" class="pb-10">
                        <div class="mb-2">
                          <div class="flex items-center gap-x-2">
                            <label class="dark:text-darkblue-200 text-sm font-semibold text-secondary-600 block mb-2">
                              {{$t('plantilla_pdf.logo_custom_previsualizacion')}}
                            </label>
                            <base-button-icon
                              v-if="logoData.hasLogoSaved"
                              name="cross"
                              size="xs"
                              iconSize="xs"
                              mode="primary-phantom"
                              @click="handleRemoveLogo(index)"/>
                          </div>
                          <el-switch class="switch-text break-normal both-switch mb-4 mt-2"
                            v-model="modosRecorte[index]"
                            :active-text="$t('plantilla_pdf.recorte_on')"
                            :inactive-text="$t('plantilla_pdf.recorte_off')"
                            inactive-color="var(--primary-800)"
                            :disabled="!selected || numLogos < index + 1"
                          />
                          <div v-if="!modosRecorte[index]">
                            <div class="mt-1 w-full">
                              <div class="flex items-center gap-x-2">
                                <div class="w-[304px] h-[px] border-2 border-solid border-primary-300 dark:bg-white rounded flex items-center justify-center">
                                  <img
                                    id="logo-custom-client-light-centered"
                                    :src="logoData.srcImage"
                                    :alt="`${$t('personalization.logo_custom')} ${index + 1}`"
                                    class=" object-contain object-left w-[304px] h-[78px] m-1"
                                  />
                                </div>
                              </div>
                            </div>
                          </div>
                          <div v-else>
                            <Cropper
                              :ref="`cropperLogo${index}`"
                              :src="logoData.srcImage"
                              :stencil-props="stencilProps"
                              @ready="maximizarRecorte(`cropperLogo${index}`)"
                            />
                            <div class="w-full flex justify-end mt-4">
                              <base-button
                                mode="primary"
                                :text="$t('app.recortar')"
                                @click="recortarLogo(index)"
                                :loading="isGeneralLoading"
                                :disabled="!selected || numLogos < index + 1"
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </template>
            </div>
            <div>
              <base-collapsible-form 
                ref="baseCollapsibleCustomFooter" 
                class="mt-2 bg-white dark:bg-darkblue-900 rounded-lg border-solid border-primary-100 dark:border-darkblue-600 border pr-4 pl-4 mb-2">
                <template slot="headerRight">
                  <h4 class="dark:text-darkblue-200 font-bold mt-4 mb-4 text-sm">{{$t('plantilla_pdf.custom_footer')}}</h4>
                </template>
                <template slot="content">

                  <div class="lg:mb-2">
                    <el-input
                      clearable
                      class="w-full"
                      v-model="form.FooterContent"
                      maxlength='4000'
                      type="textarea"
                      resize="none"
                      rows="6"
                      :disabled="!selected"
                    />
                    <TextEditor v-if="false"
                      ref="textEditorCustomFooter"
                      :contentDefault="contentTextEditorDefaultFooter"
                      idDefault="Footer"
                      custom-filename="footer-template"
                      class="mb-4"
                      :tags="tagsCustomFooter"
                      :disableEditor="!selected"
                    />
                  </div>
                </template>
              </base-collapsible-form>
            </div>
          </el-form>
        </div>
      </template>
      <template slot="RightCol">
        <div v-show="selected && showHtml" :class="{ 'h-screen': hasPdf }"
          class="bg-primary-50 dark:bg-darkblue-800 dark:text-darkblue-200 xl:inline-block relative w-full flex-grow hideHScroll lg:h-full divide-y-2 divide-blue-200 dark:divide-gray-800">
          <PDFViewerApp v-show="hasPdf" :search="actualFilterContent"
            @pdfViewerOpenHandler="pdfViewerOpenHandler" :pdf="pdfUrl" :name="pdfName" />
          <div v-if="!hasPdf" class="w-full h-full p-2 flex flex-col">
            <div v-if="!isGeneralLoading" class="lg:mb-2 lg:mt-2 text-center">{{$t('plantilla_pdf.final_pdf_may_differ_advice')}}</div>
            <iframe id="container-xhtml-iframe" class="transformed-result"></iframe>
          </div>
        </div>
      </template>
      <template slot="layout-extend">
        <base-footer>
          <template slot="actions">
            <base-button-responsive mode="secondary" :text="isFromClient ? $t('app.cancel') : $t('app.back')" icon="cross"
              @click="goBack" :loading="isGeneralLoading" />
            <base-button-responsive mode="primary" :text="$t('app.save')" icon="check" @click="submitForm('ruleForm')"
              :loading="isGeneralLoading" :disabled="isGeneralLoading" />
          </template>
        </base-footer>
      </template>
    </detail-layout-two-columns>
    <detail-layout-full-width v-else class="h-full">
      <template slot="header">
        <base-header icon="user" :content="header" />
      </template>
      <template slot="main">
        <div class="dark:text-white">{{ $t('feedback.error.absent_module_error') }}</div>
      </template>
      <template slot="layout-extend">
        <base-footer>
          <template slot="actions">
          </template>
        </base-footer>
      </template>
    </detail-layout-full-width>
  </div>
</template>

<script>
import DetailLayoutFullWidth from '@/components/layout/DetailLayoutFullWidth.vue'
import DetailLayoutTwoColumns from '@/components/layout/DetailLayoutTwoColumns.vue'
import TextEditor from '@/components/texteditor/TextEditor.vue'
import PDFViewerApp from '@/components/pdf/PDFViewerApp.vue'
import Loading from 'vue-loading-overlay'
import { Upload } from 'element-ui'

import { i18n } from '@/i18n'
import { getCompany } from '@/services/companies/getCompany'
import { genericGETFile } from '@/services/genericGETFile'
import { getPlantillasImagenCompany } from '@/services/companies/getPlantillasImagenCompany'
import { getPlantillaContentCompany } from '@/services/companies/getPlantillaContentCompany'
import { updatePlantillaXsltConfig } from '@/services/companies/updatePlantillaXsltConfig'
import { Cropper } from 'vue-advanced-cropper'
import 'vue-advanced-cropper/dist/style.css'

export default {
  name: 'xslt-template-config',
  components: {
    DetailLayoutTwoColumns,
    DetailLayoutFullWidth,
    PDFViewerApp,
    TextEditor,
    Loading,
    Cropper,
    Upload
  },
  data () {
    return {
      activeName: 'es',
      tooltipContentLogo: i18n.t('validation.not_single_valid_extension', { ext: '.png' }), // PLANTILLA PDF DE MIS EMPRESAS
      header: {
        title: i18n.t('plantilla_pdf.header'),
        icon: 'config',
        breadcrumb: {},
        nav: [],
        url: 'companies/detail'
      },
      form: {
        idPlantilla: '',
        positionQRVerifactu: 2,
        textoIzq: false,
        TraducirParaExtranjeros: false,
        FooterContent: ''
      },
      modosRecorte: [false, false],
      stencilProps: {
        aspectRatio: 300 / 74,
        stencilSize: { width: 300, height: 74 }, 
        stencilResizable: false, 
      },
      maxSizefile: 1048576, // Bytes (1MB)
      fileLogo1: {
        name: '',
        b64: '',
        bytes: null,
      },
      fileLogo2: {
        name: '',
        b64: '',
        bytes: null,
      },
      contentTextEditorDefaultFooter: '',
      tagsCustomFooter: [],
      isMounted: false,


      showHtml: false,
      generatedHtml: '',
      lasttemplate: null,
      lastpdf: {
        name: '',
        url: ''
      },
      baseTemplates: [],
      inheritTemplate: null,
      exampleXml: '',
      defaultHtml: i18n.t('plantilla_pdf.xslt_not_valid'),
      actualFilterContent: null,
      haseditor: false,
    }
  },
  watch: {
    form: {
      deep: true,
      immediate: true,
      handler: 'watchFormHandler'
    },
    logosList: {
      deep: true,
      immediate: true,
      handler: 'watchFormHandler'
    },
    'form.textoIzq' (value) {
      if (this.showHtml) {
        this.changePDF()
      }
    },
    showHtml (newValue) {
      if (newValue) {
        this.changePDF()
        this.lastpdf.name = this.selected.Nombre
        this.lastpdf.url = this.b64Pdf ? `data:application/pdf;base64,${this.b64Pdf}` : ''
      }
    },
    generatedHtml (value, oldValue) {
      this.insertIframeContent()
    },
  },
  computed: {
    isLower1024: function () {
      return this.$store.getters['app/getIsLower1024']
    },
    isGeneralLoading: function () {
      return this.$store.getters.isLoading
    },
    id () {
      return this.$route.params.id ? this.$route.params.id : -1
    },
    isFromClient () {
      return this.id !== -1
    },
    hasModuleCustomXslt () {
      return this.$store.getters['auth/hasXsltModule']
    },
    role: function () {
      return this.$store.getters['auth/role']
    },
    hasPdf: function () {
      return !!((!this.form.textoIzq && this.selected?.PdfEjemplo) || (this.form.textoIzq && this.selected?.PdfEjemploIzq))
    },
    b64Pdf: function () {
      return this.form.textoIzq ? this.selected?.PdfEjemploIzq : this.selected?.PdfEjemplo
    },
    pdfUrl: function () {
      return (this.b64Pdf && this.showHtml ? `data:application/pdf;base64,${this.b64Pdf}` : this.lastpdf.url) || ''
    },
    pdfName: function () {
      return this.selected?.Nombre || this.lastpdf.name || ''
    },
    logosList () {
      return [this.fileLogo1, this.fileLogo2].map(fileLogo => ({
        fileLogo: fileLogo,
        hasLogoSaved: fileLogo && fileLogo.b64,
        validLogoImage: fileLogo && fileLogo.b64 && this.isValidExtension(fileLogo.name),
        srcImage: fileLogo && fileLogo.b64 ? 'data:image/png;base64, ' + fileLogo.b64 : null
      }))
    },
    rules: function () {
      const rules = {
        idPlantilla: [
          {
            required: false,
            message: i18n.t('validation.complete'),
            trigger: ['blur', 'change']
          },
        ],
      }
      for (let index = 0; index < this.logosList.length; index++) {
        rules[`fileLogo${index + 1}`] = [
          {
            message: i18n.t('validation.not_single_valid_extension', { ext: '.png' }),
            trigger: ['blur', 'change'],
            validator: (rule, value, callback) => {
              const logoData = this.logosList[index]
              if (logoData.fileLogo.name &&
              (logoData.fileLogo.name.length < 5 ||
              (!this.isValidExtension(logoData.fileLogo.name)))
              ) {
                callback(new Error(i18n.t('validation.not_single_valid_extension', { ext: '.png' })))
              } else {
                callback()
              }
            }
          },
          {
            message: i18n.t('validation.popup.logo_recortar_optional'),
            trigger: ['blur', 'change'],
            validator: (rule, value, callback) => {
              const logoData = this.logosList[index]
              if (logoData.fileLogo.name && this.modosRecorte[index]) {
                callback(new Error(i18n.t('validation.popup.logo_recortar_optional')))
              } else {
                callback()
              }
            }
          },
        ]
      }
      return rules
    },
    hasLogo1Saved () {
      return this.fileLogo1 && this.fileLogo1.b64
    },
    hasLogo2Saved () {
      return this.fileLogo2 && this.fileLogo2.b64
    },
    hasLogos () {
      return this.hasLogo1Saved || this.hasLogo2Saved
    },
    clearable () {
      return this.form.idPlantilla !== this.inheritTemplate?.idPlantilla
    },
    selected () {
      return this.baseTemplates.find(x => (x.idPlantilla || '') === this.form.idPlantilla)
    },
    numLogos () {
      // return this.selected?.NumLogos ?? 0
      return this.selected?.NumLogos ?? 1
    },
    // gettextEditorCustomFooter () {
    //   if (!this.isMounted) return
    //   return this.$refs.textEditorCustomFooter.getContent()
    // },
    optionsQR: function () {
      return this.$store.getters['config/TIPOS_POSICION_QR']
    }
  },
  created: async function () {
    const breadcrumbs = []

    breadcrumbs.push({
      path: 'companies',
      name: i18n.t('companies.header')
    })
    const cabeceraStored = this.$store.getters['app/headerBreadCrumb']
    if (this.$store.getters['app/fromRouteName'] !== null && cabeceraStored) {
      breadcrumbs.push({ path: '', name: cabeceraStored })
    } else {
      const company = await this.downloadData(this.id)
      breadcrumbs.push({ path: '', name: company.RazonSocial })
      this.$store.commit('app/setheaderBreadCrumb', company.RazonSocial)
    }

    this.header.breadcrumb = breadcrumbs

    if (this.hasModuleCustomXslt) {
      try {
        this.$store.commit('setIsLoading', true)
        const dataXslt = await this.downloadDataXslt(this.id)
        this.setDataXslt(dataXslt?.Respuesta)
        if (this.showHtml) {
          this.generateHtmlFromXslt()
        }
      } finally {
        this.$store.commit('setIsLoading', false)
      }
    }
  },
  mounted () {
    this.isMounted = true
  },
  unmounted () {
    this.isMounted = false
  },
  methods: {
    isValidExtension (fileName) {
      if (!fileName || fileName.length < 5) return false
      const extension = this.getExtensionFromFile(fileName).toUpperCase()
      return extension === 'PNG' || extension === 'WEBP' ||
        extension === 'JPG' || extension === 'JPEG'
    },
    
    recortarLogo: async function (index) {
      const b64 = await this.cropImage(`cropperLogo${index}`)
      this.logosList[index].fileLogo.b64 = b64
      this.modosRecorte[index] = false
    },
    
    cropImage: async function (refName) {
      const refs = this.$refs[refName]
      if (!refs) return

      const ref = Array.isArray(refs) ? refs[0] : refs
      if (!ref) return
      const result = ref.getResult()
      
      const targetWidth = 300
      const targetHeight = 74
      const resizedCanvas = document.createElement('canvas')
      resizedCanvas.width = targetWidth
      resizedCanvas.height = targetHeight

      const ctx = resizedCanvas.getContext('2d')
      ctx.drawImage(result.canvas, 0, 0, targetWidth, targetHeight)

      return new Promise(resolve => {
        resizedCanvas.toBlob(async blob => {
          const b64 = await this.blobToBase64(blob)
          resolve(b64)
        }, 'image/png')
      })
    },
    
    blobToBase64 (blob) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader()
        reader.onloadend = () => resolve(reader.result.split(',')[1])
        reader.onerror = reject
        reader.readAsDataURL(blob)
      })
    },
    watchFormHandler () {
      // this.$store.commit('app/setFormChanges', true)
      if (this.selected && this.showHtml) {
        this.lastpdf.name = this.selected.Nombre
        this.lastpdf.url = this.b64Pdf ? `data:application/pdf;base64,${this.b64Pdf}` : ''
      }
    },
    handleChangeLogo: function (fileLogo, index) {
      const refName = 'uploadlogo'
      if (!this.$refs[refName]) return

      const ref = Array.isArray(this.$refs[refName]) ? this.$refs[refName][index] : this.$refs[refName]
      ref.clearValidate()
      this.logosList[index].fileLogo.name = fileLogo.name
      this.getBase64(fileLogo.raw).then(res => {
        const b64 = res.split(',')
        this.logosList[index].fileLogo.b64 = b64[1]
      })
      this.logosList[index].fileLogo.bytes = fileLogo
    },
    handleRemoveLogo: function (index) {
      this.logosList[index].fileLogo.name = null
      this.logosList[index].fileLogo.b64 = null
      this.logosList[index].fileLogo.bytes = null
    },
    downloadData: async function (id) {
      let company = null
      try {
        this.$store.commit('setIsLoading', true)
        const params = {
          IdCIFEmpresa: id
        }
        const response = await getCompany(params)
        if (response.blnError === true) {
          this.doFeedback(i18n.t('feedback.error.formated_api_response_error', response))
        }
        company = response.CIFEmpresa
      } catch (error) {
        this.doFeedback()
      } finally {
        this.$store.commit('setIsLoading', false)
      }
      return company
    },
    submitForm: function (formName) {
      this.$store.commit('setAjaxRequestPending', true)
      this.$store.commit('setIsLoading', true)
      this.$refs[formName].validate(async valid => {
        if (valid) {
          const params = {
            IdCIFEmpresa: this.id,
            idPlantilla: this.form.idPlantilla,
            PositionQROption: this.form.positionQRVerifactu,
            TextoIzq: !!this.form.textoIzq,
            TraducirParaExtranjeros: !!this.form.TraducirParaExtranjeros,
            Logo: this.fileLogo1 && this.fileLogo1.b64 && this.fileLogo1.name
              ? {
                Contenido: this.fileLogo1.b64,
                Extension: this.getExtensionFromFile(this.fileLogo1.name)
              }
              : null,
            // Se deja comentado para futura implementación de múltiples logos (quitar "Logo" y descomentar "Logo1" y "Logo2")
            // Logo1: this.fileLogo1 && this.fileLogo1.b64 && this.fileLogo1.name
            //   ? {
            //     Contenido: this.fileLogo1.b64,
            //     Extension: this.getExtensionFromFile(this.fileLogo1.name)
            //   }
            //   : null,
            // Logo2: this.fileLogo2 && this.fileLogo2.b64 && this.fileLogo2.name
            //   ? {
            //     Contenido: this.fileLogo2.b64,
            //     Extension: this.getExtensionFromFile(this.fileLogo2.name)
            //   }
            //   : null,
            FooterContent: this.htmlEncode(this.form.FooterContent),
            // FooterContent: this.gettextEditorCustomFooter,
          }
          const response = await updatePlantillaXsltConfig(params)
          if (response.blnError === true) {
            this.doFeedback(i18n.t('feedback.error.formated_api_response_error', response))
          } else {
            this.doFeedback(i18n.t('feedback.success.saved_data_msg'), 'success')
          }
        } else {
          this.doFeedback(i18n.t('feedback.error.process_data_error'))
        }
        this.$store.commit('setIsLoading', false)
      })
    },
    goBack: function () {
      this.$router.push({ name: this.header.url, params: this.id })
    },
    downloadDataXslt: async function (id) {
      try {
        const template = await getPlantillasImagenCompany({ idTipoPlantilla: 1, idCIFEmpresa: id })
        if (template.blnError === true) {
          this.doFeedback(i18n.t('feedback.error.formated_api_response_error', template))
        } else {
          return template
        }
      } catch (error) {
        this.doFeedback()
      }
      return null
    },
    setDataXslt: function (data) {
      if (data) {
        this.baseTemplates = data.templates || []
        if (data.inherit) {
          this.inheritTemplate = data.inherit
          this.baseTemplates.unshift(data.inherit)
        }
        this.form.idPlantilla = data.config?.PlantillaActiva?.idPlantilla ?? ''
        this.form.positionQRVerifactu = data.config?.PositionQROption ? data.config?.PositionQROption === 0 ? 2 : data.config?.PositionQROption : 2
        this.form.textoIzq = !!data.config?.TextoIzq
        this.form.TraducirParaExtranjeros = !!data.config?.TraducirParaExtranjeros
        
        const logo1 = data.config?.Logo1 ?? data.Logo
        this.fileLogo1.b64 = logo1?.Contenido
        this.fileLogo1.name = logo1
          ? 'custom-logo.' + logo1?.Extension
          : null
        this.fileLogo2.b64 = data.config?.Logo2?.Contenido
        this.fileLogo2.name = data.config?.Logo2
          ? 'custom-logo.' + data.config?.Logo2?.Extension
          : null
        this.form.FooterContent = this.htmlDecode(data.config?.FooterContent) ?? ''
        // this.contentTextEditorDefaultFooter = data.config?.FooterContent ?? ''
        this.tagsCustomFooter = data.tags
        if (this.selected) {
          this.$nextTick(() => { this.showHtml = true })
        }
      } else {
        this.baseTemplates = []
      }
    },
    toggleHtml: function () {
      this.showHtml = !this.showHtml
    },
    async generateHtmlFromXslt () {
      if (!this.hasPdf) {
        if (this.selected && this.lasttemplate?.Contenido !== this.selected?.Contenido) {
          try {
            this.$store.commit('setIsLoading', true)
            this.lasttemplate = JSON.parse(JSON.stringify(this.selected))
            const xslt = this.selected?.Contenido
    
            const parser = new DOMParser()
            const xsltDoc = parser.parseFromString((xslt || ''), 'application/xml')
            if (!this.exampleXml) {
              const response = await genericGETFile('/api/personalizacion/getxmlejemplo')
              this.exampleXml = await response.data.text()
            }
            const xmlDoc = parser.parseFromString(this.exampleXml, 'application/xml')
    
            const xsltProcessor = new XSLTProcessor()
            xsltProcessor.importStylesheet(xsltDoc)
            let resultDoc = xsltProcessor.transformToDocument(xmlDoc)
    
            if (!resultDoc) {
              resultDoc = parser.parseFromString(this.defaultHtml, 'text/html')
            }
    
            const serializer = new XMLSerializer()
            let transformedHtml = serializer.serializeToString(resultDoc)
    
            transformedHtml = transformedHtml.replace(/<script\b[^<]*(?:(?!<\/script>)<[^<]*)*<\/script>/gi, '')
            transformedHtml = transformedHtml.replace(/<script\b[^<]*\/>/gi, '')
            transformedHtml = transformedHtml.replace(/<[^>]*\bon[^=]*=[^>]*>/gi, '')
    
            this.generatedHtml = transformedHtml
          } finally {
            this.$store.commit('setIsLoading', false)
          }
        } else {
          this.$nextTick(() => this.insertIframeContent())
        }
      }
    },
    insertIframeContent () {
      try {
        this.$store.commit('setIsLoading', true)
        let iframe = document.getElementById('container-xhtml-iframe')
  
        if (iframe) {
          iframe.addEventListener('load', () => {
            const doc = iframe?.contentDocument || iframe?.document || iframe
            const style = doc.createElement('style')
            style.textContent= this.getScrollBarsStyle()
            style.textContent += '.page { padding: 15mm; } @media not print { html { max-height: 100%; } body { width: 210mm; height: 297mm; overflow-x: hidden; } body { transform-origin: top left; transform: scale(calc(100vw / 210mm)); } }'
            if (!doc.head) {
              const head = doc.createElement('head')
              head.appendChild(style)
              doc.appendChild(head)
            } else {
              doc.head.appendChild(style) 
            }
          })
          iframe = iframe.contentWindow || (iframe.contentDocument.document || iframe.contentDocument)
    
          iframe.document.open()
          iframe.document.write(this.generatedHtml)
          iframe.document.close()
        }
      } finally {
        this.$store.commit('setIsLoading', false)
      }
    },
    getScrollBarsStyle: function () {
      const computedStyle = getComputedStyle(document.documentElement)
      const variableNames = ['--primary-400', '--primary-500', '--Component-background-']
      const rootStyle = variableNames.map(x => `${x}: ${computedStyle.getPropertyValue(x)}`).join('; ')
      return `:root { ${rootStyle} } ::-webkit-scrollbar { width: 8px; height: 8px; } ::-webkit-scrollbar-track { background-color: transparent; } ::-webkit-scrollbar-thumb { background-color: var(--primary-400); border-radius: 20px; } ::-webkit-scrollbar-corner { background: var(--Component-background-); } ::-webkit-scrollbar-thumb:hover { background: var(--primary-500); } ::-webkit-scrollbar-button { height: 2px; width: 2px; }`
    },
    optionValue (option) {
      return option.idPlantilla || ''
    },
    onBaseTemplateInput (value) {
      if (this.showHtml) {
        this.changePDF()
      }
    },
    pdfViewerOpenHandler () {
      this.actualFilterContent = null
    },
    async changePDF () {
      if (!this.selected.Contenido) {
        const content = await this.downloadXsltContent()
        if (!content) {
          return
        }
        Object.keys(content).forEach(key => this.$set(this.selected, key, content[key]))
      }
      if (this.form.textoIzq) {
        if (!this.selected.PdfEjemploIzq) {
          this.generateHtmlFromXslt()
        }
      } else {
        if (!this.selected.PdfEjemplo) {
          this.generateHtmlFromXslt()
        }
      }
    },
    async downloadXsltContent () {
      try {
        this.$store.commit('setIsLoading', true)
        const idPlantilla = this.form.idPlantilla || this.selected.idPlantillaHeredada
        const response = await getPlantillaContentCompany({ idPlantilla, idTipoPlantilla: 1, idCIFEmpresa: this.id })
        if (response.blnError === true) {
          this.doFeedback(i18n.t('feedback.error.formated_api_response_error', response))
        } else {
          return response?.Respuesta
        }
      } catch (error) {
        this.doFeedback()
      } finally {
        this.$store.commit('setIsLoading', false)
      }
    }
  }
}
</script>

<style scoped>
.transformed-result {
  background-color: var(--secondary-100) !important;
  border-bottom-left-radius: 5px !important;
  border-bottom-right-radius: 5px !important;
  margin-top: 5px;
  margin-inline: auto;
  width: 100%;
  height: 100%;
  max-height: 297mm;
  max-width: 210mm;
  box-sizing: border-box;
}
@media (min-width: 1024px) {
  .layout-detail-two-columns.haspdf::v-deep > main {
    overflow-y: hidden;
  }
}

#pfxselector:has(.is-disabled)::v-deep * {
 cursor: not-allowed;
}

.hideHScroll {
  overflow-x: hidden;
}
</style>
<style lang="scss" scoped>
::v-deep #customToolbarFooter {
  .ql-font, .ql-list[value=check], .ql-link {
    display: none;
  }
}
</style>
